import Voltorb from './Voltorb';

export default Voltorb;



/** WEBPACK FOOTER **
 ** ./source/100-voltorb/index.js
 **/